import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Auth, authState } from '@angular/fire/auth';
import { map, take, tap } from 'rxjs/operators';
import { nav_path } from '../../app-routing.module';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService,
    private auth: Auth
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return authState(this.auth).pipe(
      take(1),
      map(user => !!user),
      tap((isLoggedIn) => {
        if (!isLoggedIn) {
          this.router.navigate([nav_path.signIn], { queryParams:{'redirectURL':state.url} });
        }
      })
    )
  }

}
